<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('setting') }}  {{ $t('integrator') }} </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      class="mt-2"
      lazy-validation
    >
      <v-row class="mx-2">
        <v-tabs>
          <v-tab>{{ $t('cms') }}</v-tab>
          <v-tab :disabled="($store.state.webhook == 'active' ? false : true)">
            {{ $t('webhook') }}
          </v-tab>
          <v-tab-item>
            <v-container>
              <v-row class="pa-0 ma-0">
                <v-tabs
                  vertical
                >
                  <v-tab :disabled="($store.state.woocommerce == 'active' ? false : true)">
                    <v-icon class="me-3">
                      mdi-wordpress
                    </v-icon>
                    {{ $t('woocommerce') }}
                  </v-tab>
                  <v-tab
                    align="right"
                    :disabled="($store.state.digikala == 'active' ? false : true)"
                  >
                    <img
                      width="20"
                      class="me-2"
                      src="@/assets/digikala.png"
                    >
                    {{ $t('digikala') }}
                  </v-tab>
                  <v-tab
                    align="right"
                    :disabled="($store.state.basalam == 'active' ? true : true)"
                  >
                    <img
                      width="20"
                      class="me-2"
                      src="@/assets/basalam.png"
                    >
                    {{ $t('basalam') }}
                  </v-tab>
                  <v-tab :disabled="($store.state.markito == 'active' ? false : true)">
                    <img
                      width="20"
                      class="me-4"
                      src="@/assets/markitoLogo.png"
                    >
                    {{ $t('markito') }}
                  </v-tab>
                  <v-tab :disabled="($store.state.portal == 'active' ? false : true)">
                    <img
                      width="10"
                      class="me-4"
                      src="@/assets/portal.png"
                    >
                    {{ $t('portal') }}
                  </v-tab>
                  <v-tab :disabled="($store.state.sazito == 'active' ? false : true)">
                    <img
                      width="20"
                      class="me-4"
                      src="@/assets/sazito.png"
                    >
                    {{ $t('sazito') }}
                  </v-tab>
                  <v-tab :disabled="($store.state.webzi == 'active' ? false : true)">
                    <img
                      width="20"
                      class="me-4"
                      src="@/assets/webzi.png"
                    >
                    {{ $t('webzi') }}
                  </v-tab>
                  <v-tab-item>
                    <v-container>
                      <setting-woocommerce v-if="$store.state.woocommerce == 'active'" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container
                      class="pt-0"
                      fluid
                    >
                      <setting-digikala v-if="$store.state.digikala == 'active'" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container>
                      basalam
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container>
                      <setting-markito />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container
                      class="pt-0"
                      fluid
                    >
                      <setting-portal v-if="$store.state.portal == 'active'" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container
                      class="pt-0"
                      fluid
                    >
                      <setting-sazito v-if="$store.state.sazito == 'active'" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container
                      class="pt-0"
                      fluid
                    >
                      <setting-webzi v-if="$store.state.webzi == 'active'" />
                    </v-container>
                  </v-tab-item>
                </v-tabs>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <setting-webhook />
          </v-tab-item>
        </v-tabs>
      </v-row>
      <v-card-actions>
        <v-row class="ma-0" />
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  import settingPortal from './settingPortal'
  import settingWoocommerce from './settingWoocommerce'
  import settingDigikala from './settingDigikala'
  import settingWebhook from './settingWebhook'
  import settingMarkito from './settingMarkito.vue'
  import settingSazito from './settingSazito.vue'
  import settingWebzi from './settingWebzi.vue'
  import General from '../../../../Mixins/general'
import SettingDigikala from './settingDigikala.vue'
  export default {
    name: 'Customer',
    components: {
      // aicomplete,
      settingPortal,
      settingMarkito,
      settingWoocommerce,
      settingSazito,
      settingWebhook,
      settingWebzi,
      settingDigikala,
        SettingDigikala,
    },
    mixins: [General],
    data: () => ({
      valid: true,
      render: true,
    }),
    watch: {
    },
    activated () {
      this.show()
    },
    beforeMount () {
    },
    mounted () {
    },
    methods: {
    },
  }
</script>

<style scoped>
.col{
  height: 55px !important;
}
</style>
